module.exports = __webpack_public_path__ + "static/media/cart.37ae03a9.svg";